import { MediaType } from "@modules/sessionBlock/media/mediaTypes"
import { z } from "zod"

export const MediaItemDtoSchema = z.object({
  id: z.string(),
  url: z.string(),
  type: z.nativeEnum(MediaType),
  filename: z.string().nullable(),
  key: z.string().nullish(), // S3 key, for backward compatibility - can be undefined
})

export const MediaDtoSchema = z.object({
  medias: z.array(MediaItemDtoSchema),
})

export type MediaDto = z.infer<typeof MediaDtoSchema>

export const MediaItemDraftDtoSchema = z.object({
  id: z.string().nullish(),
  url: z.string().nullish(),
  awsS3Key: z.string().nullish(),
  key: z.string().nullish(), // same as awsS3Key, but for comments
  type: z.nativeEnum(MediaType),
  filename: z.string().nullish(),
})

export const MediaDraftDtoSchema = z.object({
  medias: z.array(MediaItemDraftDtoSchema),
})
export type MediaDraftDto = z.infer<typeof MediaDraftDtoSchema>
export type MediaItemDraftDto = z.infer<typeof MediaItemDraftDtoSchema>
